import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import actions from "../redux/actions";
import Layout from "../layouts/Layout";
import liff from "@line/liff";
import apiService from '../utils/api.service';
import helper from '../utils/helper';
import { Button, Modal } from 'antd';
import _ from 'lodash'

// const MOCKLINEID = helper.CONFIG.MOCKLINEID
const devtool = helper.CONFIG.DEVTOOL
const Lineliff = (props) => {
  const setLineUser = (lineId) => {
    props.setUser({ lineId: lineId });
  };
  const getLineLIFF = async () => {
    try {
        // alert('ENV >> ' + process.env.REACT_APP_ENV)
        // alert('liffId >> ' + props.liffId)
        await liff.init({ liffId: props.liffId }).catch((err) => {
          alert(err)
          throw err;
        });
        const idToken = liff.getDecodedIDToken();
        console.log('idToken >> ', idToken); // print decoded idToken object
        if (idToken) {
            getProfileByLiffId(idToken.sub)
        } else {
            throw 404
        }
    } catch (e) {
        console.log('e >> ',e )
        // alert(e)
        // getProfileByLiffId(MOCKLINEID)
    }
  };
  const info = () => {
    Modal.info({
      title: 'Debug',
      content: (
        <div>
            { 
                props.user 
                ? 
                <>
                    <p>Lineid : { props.user?.lineId?.lineId }</p>
                    <p>MemberId : { props.user?.lineId?.memberId }</p>
                    <p>Latitude : { props.location?.latitude }</p>
                    <p>Longitude : { props.location?.longitude }</p>
                    {/* <p>MemberId : { props.user.memberId }</p> */}
                </>
                : null
            }
        </div>
      ),
      onOk() {},
    });
  };
  const getProfileByLiffId = async (lineId) => {
    try {
      // alert('lineId >> ' + lineId)
      const payload = { lineId : lineId }
      const { resData } = await apiService.Profile.SearchId(payload)
      if (resData.resultCode === "20000") {
          let data = _.cloneDeep(resData.data)
          data.lineId = lineId
          console.log('data get >>', data)
          const payload2 = { memberId : data.memberId }
          const res2 = await apiService.Profile.SearchMember(payload2)
          const resData2 = res2.resData
          console.log('resData2 >>', resData2)
          if (resData2.resultCode === "20000") {
            data.memberPayment = resData2?.data.memberPayment
          }
          console.log('data2 get >>', data)
          setLineUser(data)
          props.callBack(data)
      } else {
        setLineUser(payload)
        throw 404
      }
    }
    catch(e){
        console.log('API ERR', e)
        props.callBack(null)
    }
  }
  useEffect(() => {
    // alert(JSON.stringify(liff.ready()))
    getLineLIFF();
  }, []);

  return (
    <div className={`dev-tool ${ devtool ? 'active' : '' }`}>
        <Button onClick={info}>Info</Button>
        {props.liffId}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps, actions)(Lineliff);
